export enum StepState {
  Future = 'future',
  Active = 'active',
  Done = 'done',
}
